export default __webpack_public_path__ + "static/media/ic-file-error.3d53c223.svg";